import './global.css'
import { AuthProvider } from '@/components/contexts/auth.context.tsx'
import { NotFound } from '@/components/layouts/404.tsx'
import { Toaster } from '@/components/ui/sonner.tsx'
import { useAuth } from '@/hooks/use-auth.ts'
import { queryClient } from '@/lib/react-query.ts'
import { env } from '@/utils/env.ts'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { Provider as JotaiProvider } from 'jotai'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { routeTree } from './routeTree.gen.ts'

if (!env.VITE_IS_DEV) {
  const { init } = require('@/lib/sentry.ts')
  init()
}

const router = createRouter({
  routeTree,
  context: {
    queryClient,
    auth: undefined!,
  },
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  defaultNotFoundComponent: NotFound,
  defaultStructuralSharing: true,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const App = () => {
  const auth = useAuth()

  return <RouterProvider router={router} context={{ auth, queryClient }} />
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Toaster richColors />
      <JotaiProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </JotaiProvider>
      <ReactQueryDevtools />
    </QueryClientProvider>
  </React.StrictMode>,
)
